import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Database } from '../../../../definitions/database';
import { DatabasesService } from '../../services/databases.service';

export const databaseResolverFn = (
	route: ActivatedRouteSnapshot
): Observable<Database> => {
	const databasesSvc = inject(DatabasesService);
	const databaseId = route.paramMap.get('databaseId');

	return databaseId
		? databasesSvc.find(databaseId).pipe(catchError(() => of(null)))
		: of(null);
};
